// FL-05 · Romaneio de Entrega — PDF em 2 vias conforme modelo do Regimento (rev.02)
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import QRCode from "qrcode";

const NAVY = [16, 42, 74];
const GOLD = [201, 168, 76];
const TEXT = [30, 41, 59];
const MUTED = [100, 116, 139];
const BORDER = [180, 188, 200];
const PW = 210;
const M = 10;

const fData = (s) => (s ? new Date(String(s).slice(0, 10) + "T00:00:00").toLocaleDateString("pt-BR") : "___/___/_____");
const fHora = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { hour: "2-digit", minute: "2-digit" }) : "___:___");

function campo(doc, x, y, w, label, valor) {
  doc.setFontSize(5.8).setTextColor(...MUTED).setFont("helvetica", "bold");
  doc.text(label.toUpperCase(), x, y);
  doc.setFontSize(8).setTextColor(...TEXT).setFont("helvetica", "normal");
  const v = String(valor ?? "").trim();
  doc.text(v ? doc.splitTextToSize(v, w - 1)[0] : "", x, y + 3.6);
  doc.setDrawColor(...BORDER).setLineWidth(0.15);
  doc.line(x, y + 4.6, x + w - 3, y + 4.6);
}

function desenharVia(doc, r, via, qrDataUrl) {
  // ---- cabecalho ----
  doc.setFillColor(...NAVY).rect(0, 0, PW, 15, "F");
  doc.setFillColor(...GOLD).rect(0, 15, PW, 1.1, "F");
  doc.setTextColor(255, 255, 255).setFont("helvetica", "bold").setFontSize(12);
  doc.text("FL-05 · Romaneio de Entrega", M, 7.5);
  doc.setFontSize(7).setFont("helvetica", "normal").setTextColor(220, 225, 235);
  doc.text("OBRASUL · Um Show de Obra", M, 11.8);
  doc.setFont("helvetica", "bold").setFontSize(9).setTextColor(...GOLD);
  doc.text(`Romaneio Nº ${r.numero || ""}`, PW - M - 26, 7.5, { align: "right" });
  doc.setFontSize(6.5).setFont("helvetica", "normal").setTextColor(220, 225, 235);
  doc.text(via === 1 ? "1ª VIA — FICA NA OBRA (grampear no FL-01)" : "2ª VIA — VOLTA ASSINADA PARA A LOGÍSTICA", PW - M - 26, 11.8, { align: "right" });
  if (qrDataUrl) {
    doc.setFillColor(255, 255, 255).rect(PW - M - 21, 1.8, 21, 21, "F");
    doc.addImage(qrDataUrl, "PNG", PW - M - 20, 2.8, 19, 19);
    doc.setFontSize(5).setTextColor(...MUTED);
    doc.text("Conferência digital", PW - M - 10.5, 25.3, { align: "center" });
  }

  // ---- campos do cabecalho ----
  let y = 22;
  const cw = (PW - 2 * M - 24) / 4;
  campo(doc, M, y, cw, "Data", fData(r.data_entrega));
  campo(doc, M + cw, y, cw * 2, "Obra / Condomínio", r.obra_titulo);
  campo(doc, M + 3 * cw, y, cw, "Cód. obra", r.obra_numero);
  y += 7.5;
  campo(doc, M, y, cw, "Nº requisição", r.numero_requisicao || "—");
  campo(doc, M + cw, y, cw * 3, "Endereço de entrega", r.endereco_entrega);
  y += 7.5;
  campo(doc, M, y, cw * 1.6, "Contato na obra / tel.", `${r.contato_obra || ""} ${r.telefone_obra ? "· " + r.telefone_obra : ""}`);
  campo(doc, M + cw * 1.6, y, cw * 0.9, "Veículo / placa", r.veiculo_placa);
  campo(doc, M + cw * 2.5, y, cw * 0.9, "Condutor", r.condutor_nome);
  campo(doc, M + cw * 3.4, y, cw * 0.6, "Ordem na rota",
    r.ordem_rota_pos ? `${r.ordem_rota_pos} de ${r.ordem_rota_total || "__"}` : "__ de __");
  y += 7.5;
  campo(doc, M, y, cw, "Origem", r.origem_descricao || "Depósito Central");
  campo(doc, M + cw, y, cw, "Saída base", fHora(r.hora_saida_base));
  campo(doc, M + 2 * cw, y, cw, "Chegada obra", fHora(r.hora_chegada_obra));
  y += 8.5;

  // ---- tabela de itens (minimo 16 linhas) ----
  const linhas = (r.linhas || []).map((l, i) => [
    i + 1,
    `${l.tipo === "patrimonio" ? `[PATR ${l.codigo || ""}] ` : ""}${l.nome}`,
    l.unidade || "un",
    Number(l.quantidade || 0).toLocaleString("pt-BR"),
    l.separado ? "X" : "",
    l.qtd_recebida != null ? Number(l.qtd_recebida).toLocaleString("pt-BR") : "",
    l.conferencia || "",
    l.observacao || "",
  ]);
  while (linhas.length < 16) linhas.push([linhas.length + 1, "", "", "", "", "", "", ""]);

  autoTable(doc, {
    startY: y,
    margin: { left: M, right: M },
    head: [["Nº", "Item / material", "Unid.", "Qtd. enviada", "Separado (X)", "Qtd. recebida", "Conf. OK/DIV", "Obs."]],
    body: linhas,
    theme: "grid",
    styles: { fontSize: 6.6, cellPadding: 1.1, textColor: TEXT, lineColor: BORDER, lineWidth: 0.15, minCellHeight: 5 },
    headStyles: { fillColor: NAVY, textColor: [255, 255, 255], fontSize: 6.2, halign: "center", cellPadding: 1.2 },
    columnStyles: {
      0: { cellWidth: 7, halign: "center" }, 1: { cellWidth: 62 }, 2: { cellWidth: 11, halign: "center" },
      3: { cellWidth: 17, halign: "center" }, 4: { cellWidth: 15, halign: "center" },
      5: { cellWidth: 18, halign: "center" }, 6: { cellWidth: 17, halign: "center" }, 7: { cellWidth: "auto" },
    },
  });
  y = doc.lastAutoTable.finalY + 3;

  // ---- instrucao ----
  doc.setFillColor(248, 246, 238).setDrawColor(...GOLD).setLineWidth(0.3);
  doc.roundedRect(M, y, PW - 2 * M, 8.5, 1, 1, "FD");
  doc.setFontSize(6.4).setTextColor(...TEXT).setFont("helvetica", "bolditalic");
  doc.text(doc.splitTextToSize(
    "Quem recebe conta na hora, escreve a quantidade recebida à caneta e marca OK ou DIV. Item com DIV: anotar na coluna Obs., registrar no FL-01 e fotografar antes de o condutor sair.",
    PW - 2 * M - 6), M + 3, y + 3.4);
  y += 11.5;

  // ---- retorno a base ----
  doc.setFont("helvetica", "bold").setFontSize(7.5).setTextColor(...NAVY);
  doc.text("RETORNO À BASE (sobras, devoluções e vazios)", M, y);
  y += 1.5;
  const ret = (r.retorno || []).map((l) => [
    l.descricao || "", l.unidade || "un", Number(l.quantidade || 0).toLocaleString("pt-BR"), l.estado || "", ""]);
  while (ret.length < 4) ret.push(["", "", "", "", ""]);
  autoTable(doc, {
    startY: y,
    margin: { left: M, right: M },
    head: [["Item", "Unid.", "Qtd.", "Estado B/R/D", "Conferido na base (rubrica)"]],
    body: ret,
    theme: "grid",
    styles: { fontSize: 6.6, cellPadding: 1.1, textColor: TEXT, lineColor: BORDER, lineWidth: 0.15, minCellHeight: 5 },
    headStyles: { fillColor: [71, 85, 105], textColor: [255, 255, 255], fontSize: 6.2, halign: "center", cellPadding: 1.2 },
    columnStyles: { 0: { cellWidth: 80 }, 1: { cellWidth: 14, halign: "center" }, 2: { cellWidth: 16, halign: "center" }, 3: { cellWidth: 24, halign: "center" }, 4: { cellWidth: "auto" } },
  });
  y = doc.lastAutoTable.finalY + 4;

  // ---- resultado do recebimento ----
  const temDiv = (r.linhas || []).some((l) => l.conferencia === "DIV");
  const conferido = (r.linhas || []).some((l) => l.conferencia);
  doc.setFont("helvetica", "bold").setFontSize(7.5).setTextColor(...NAVY);
  doc.text("RESULTADO DO RECEBIMENTO", M, y);
  doc.setFont("helvetica", "normal").setFontSize(7.2).setTextColor(...TEXT);
  const cb = (x, marcado) => {
    doc.setDrawColor(...TEXT).setLineWidth(0.25).rect(x, y + 2.2, 3, 3);
    if (marcado) { doc.setFont("helvetica", "bold"); doc.text("X", x + 0.7, y + 4.7); doc.setFont("helvetica", "normal"); }
  };
  cb(M, conferido && !temDiv); doc.text("sem divergência", M + 4.5, y + 4.7);
  const divs = (r.linhas || []).filter((l) => l.conferencia === "DIV" && l.fl01_folha);
  const folhasDiv = [...new Set(divs.map((l) => l.fl01_folha))].join(", ");
  const linhasDiv = divs.map((l) => l.fl01_linha).join(", ");
  cb(M + 34, temDiv);
  doc.text(`com divergência – FL-01 folha ${temDiv && folhasDiv ? folhasDiv : "____"} linha(s) ${temDiv && linhasDiv ? linhasDiv : "________"}`, M + 38.5, y + 4.7);
  cb(M + 112, false); doc.text("Foto lançada no Obra Padrão", M + 116.5, y + 4.7);
  y += 10;

  // ---- assinaturas ----
  const aw = (PW - 2 * M - 10) / 3;
  const ass = [
    ["Separado por (Logística)", ""],
    ["Condutor", r.condutor_nome || ""],
    ["Recebido por (obra): nome legível / assinatura / hora",
      r.recebedor_nome ? `${r.recebedor_nome} · ${fHora(r.conferido_em)}` : ""],
  ];
  ass.forEach(([lbl, v], i) => {
    const x = M + i * (aw + 5);
    doc.setDrawColor(...TEXT).setLineWidth(0.25).line(x, y + 9, x + aw, y + 9);
    doc.setFontSize(7.5).setTextColor(...TEXT).setFont("helvetica", "normal");
    if (v) doc.text(doc.splitTextToSize(v, aw)[0], x + aw / 2, y + 7.5, { align: "center" });
    doc.setFontSize(5.6).setTextColor(...MUTED);
    doc.text(doc.splitTextToSize(lbl, aw), x + aw / 2, y + 11.5, { align: "center" });
  });

  // ---- rodape ----
  doc.setFillColor(...NAVY).rect(0, 289, PW, 8, "F");
  doc.setFontSize(6.5).setTextColor(255, 255, 255).setFont("helvetica", "normal");
  doc.text("OBRASUL · Um Show de Obra · Registro físico obrigatório · FL-05 · rev.02", PW / 2, 294, { align: "center" });
}

export async function gerarRomaneioPDF(romaneio, urlConferencia) {
  const doc = new jsPDF({ unit: "mm", format: "a4", compress: true });
  let qr = null;
  try { qr = await QRCode.toDataURL(urlConferencia, { margin: 0, width: 160 }); } catch { /* sem QR */ }
  desenharVia(doc, romaneio, 1, qr);
  doc.addPage();
  desenharVia(doc, romaneio, 2, qr);
  doc.save(`FL-05_Romaneio_${romaneio.numero || ""}.pdf`);
}
